export interface AddToCartProduct {
  itemNumber: string;
  price: number;
  minimumBuy: number;
  mustBuy: number;
  feedIdentifier: string;
  outletId?: number;
}

export type AddToExistingAutoReorderResponse = {
  hasResidential: boolean;
  customerLiftgateFee: number;
  isChangedToCommonCarrier: boolean;
};
interface Params {
  product: AddToCartProduct;
  quantity: number;
  existingAutoReorderId: string;
  setAddToExistingAutoReorderResponse: (
    response: AddToExistingAutoReorderResponse
  ) => void;
}

const existingAutoReorderRequest = async ({
  product,
  quantity,
  existingAutoReorderId,
  setAddToExistingAutoReorderResponse,
}: Params): Promise<boolean> => {
  const body = new FormData();

  try {
    body.set("autoReorderId", existingAutoReorderId);
    body.set("itemNumber", product.itemNumber);
    body.set("qty", quantity.toString());

    await fetch("/myaccount:autoreorder/additemtoexistingautoreorder/", {
      body,
      method: "POST",
      credentials: "include",
      headers: {
        accept: "application/json",
      },
    })
      .then((response) => response.json<AddToExistingAutoReorderResponse>())
      .then((result) => {
        setAddToExistingAutoReorderResponse(result);
      });
  } catch (error) {
    return false;
  }

  return true;
};

export default existingAutoReorderRequest;
